import apiClient from '../client';

/** The server's check of the cart saved in this browser: prices now, products still for sale, stock left. */
export const validateCart = async ({ items, marketCode }) => {
  const { data } = await apiClient.post('/cart/validate', { items, marketCode: marketCode || null });
  return data;
};
